<template>
<div>

<div v-if="type">
      <h4 v-if="sizeList">MISURE CAMPIONATE PER BRAND,CATEGORIA,REPARTO <strong>{{ sizeList }}</strong></h4>    
</div>
<div v-else>
    <div v-if="spinner" class="spinner-grow spinner-grow-sm text-warning"   role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>  

</div>
</template>

<script>
import { mapGetters }      from 'vuex';
import api from '@/api'

  export default {
    props:['props'],
    
    data () {
      return {
        
        
        
        spinner      : false,
        items        : [],
        sizeList     : '',
        type         : false

        
      }
    },
  
    computed: 
  {
    ...mapGetters(['company']) , 
  },

    created () 
    {
      
      if(!this.props.barcodes || this.props.barcodes.length === 0)
      {        
        this.getData()  
      }
      else
      {
        
        const items = this.extractSizes(this.props.barcodes)        
        this.$emit('update',items)
      }
    },

    methods: 
    {
      

      extractSizes(items) {
      return [...new Map(
      items
      .sort((a, b) => a.colOrder - b.colOrder)
      .map(item => [item.sizeId, {
        sizeId   : item.sizeId,
        size     : item.size,
        colOrder : item.colOrder
      }])
    ).values()]


    },


      async getData()
      {
        this.items     = []
        this.type      = false
        this.sizeList  = {}
        this.spinner   = true


        const data     = {

          
          "companyId"    : this.company.Id,
          "brandId"      : this.props.brand,
          "categoryId"   : this.props.categoryId,
          "departmentId" : this.props.departmentId

        }
        

        const sp       = {'sp'   : 'spProductCustomSizesList'}
        const json     = Object.assign(data, sp)
        
        await api.post(json).then(res => {

          
          if(res.status==200)
            {   

                    
                    

                    this.items    = res.data.recordsets[0]                  
                    this.sizeList = this.items.map(s => s.size).join(',');                  
                    this.$emit('update',this.items)
                
                
            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {

          this.type = true
          this.spinner = false
        });
        
      },  

    }
  }
</script>
<style scoped>


  h4 {
  font-family : 'Roboto Condensed';
  font-size   : 16px;
}
strong{
  font-size   : 20px;
  color:darkgreen
}

</style>
